// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/mail.svg';

export const Mail = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
